import Dataset from "./Dataset";

export default class Transitions extends Dataset {
  type = "feature";
}
